import poster from '@/assets/images/login/login_video_poster.jpg'
import useWindowSize from '@/hooks/useWindowSize'
import React, { FC, useEffect } from 'react'
import { Link } from 'umi'
import { loginBack } from '@/utils/images'
import { delCookie } from '@/utils/utils'
import './index.less'

interface LoginLayoutProps {
	children: any
}

const LoginLayout: FC<LoginLayoutProps> = ({ children }) => {
	const windowSize = useWindowSize()
	useEffect(() => {
		delCookie('hnToken')
		// let video = document.querySelector('.loginVideo') as HTMLVideoElement
		// video.playbackRate = 0.5
		// setTimeout(() => {
		// 	video.play()
		// }, 1000)
	}, [])
	return (
		<div
			className="loginLayoutContainer"
			style={{
				height: `${windowSize.height}px`,
				backgroundImage: `url("${loginBack}")`,
			}}
		>
			<div className="loginLayoutContainer-left">
				<span>文脉社群</span>
				{/* <img src={mapLogin} alt="" /> */}
				{/* <video
					src="./videos/login.mp4"
					muted
					className="loginVideo"
					x5-video-player-type="h5"
					x5-video-player-fullscreen="true"
					playsInline={true}
					webkit-playsinline="true"
					x-webkit-airplay="true"
					poster={poster}
					// autoPlay
					// loop
					// playsInline
					// preload="auto"
					// poster={videoPoster_homeBg}
				></video> */}
			</div>
			<div className="loginLayoutContainer-right">
				{/* <Link className="backToHomePage" to="/">
					进入官网
				</Link> */}
				{children}
			</div>
		</div>
	)
}

export default LoginLayout
